import classNames                         from 'classnames';
import * as React                         from 'react';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide }            from 'swiper/react';
import DV                                 from 'ts-data-validator';

import './scss/style.scss';

import NextSliderArrow from '../../icons/NextSliderArrow';
import PrevSliderArrow from '../../icons/PrevSliderArrow';

import { GalleryImage, GallerySlide } from './components';

function GallerySlider(props) {
  const {
          arrows,
          dots,
          fullSize,
          infinite,
          previews,
          previewsSize = 150,
          slides: items,
        } = props;

  const previewsContainerRef = React.useRef(null);
  const swiperRef            = React.useRef(null);

  const [current, setCurrent]     = React.useState(0);
  const [isMounted, setIsMounted] = React.useState(false);

  const slides = React.useMemo(() => {
    return items
      .sort((a, b) => {
        return (a.priority === -1 || b.priority === -1)
          ? -1
          : a.priority < b.priority ? 1 : -1;
      });
  }, [items]);

  React.useEffect(() => {
    if (previews && previewsContainerRef.current && isMounted) {
      const previewItems = previewsContainerRef.current.children;

      if (previewItems.length > 0 && current < previewItems.length) {
        previewItems[current]?.scrollIntoView({
          behavior: 'smooth',
          block:    'nearest',
          inline:   'center',
        });
      }
    }
  }, [current, previews]);

  return (
    <div className={'gallerySlider'}>
      <div className={'container'}>
        <Swiper
          autoHeight
          loop={infinite}
          modules={[Navigation, Pagination, Thumbs]}
          onInit={(swiper) => {
            swiperRef.current = swiper;

            setIsMounted(true);
          }}
          onSlideChange={(swiper) => {
            setCurrent(swiper.realIndex);
          }}
          slidesPerView={1}
          speed={5e2}
        >
          {slides.map((slide, slideIndex) => {
            return (
              <SwiperSlide key={slideIndex}>
                <GallerySlide
                  fullSize={fullSize}
                  slide={slide}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        {previews && (
          <div className={'swiper_previews_wrapper'}>
            {arrows && swiperRef.current?.activeIndex > 0 && (
              // Capture phase: the arrow icon stops the click's propagation itself (it
              // doubles as a Swiper navigation element elsewhere), so a bubbling onClick
              // here never fires on a real click.
              <button
                className={'swiper_preview_button swiper_preview_button_prev'}
                onClickCapture={() => swiperRef.current.slidePrev()}
              ><PrevSliderArrow /></button>
            )}
            <div
              className={'swiper_previews_container'}
              ref={previewsContainerRef}
            >
              {slides.map((slide, index) => {
                return (
                  <div
                    className={classNames('swiper_preview_item', { active: current === index })}
                    key={index}
                    onClick={() => swiperRef.current?.slideTo(index)}
                  >
                    <GalleryImage
                      alt={slide.alt}
                      size={previewsSize}
                      src={slide.src}
                      type={slide.type}
                      url={slide.url}
                    />
                  </div>
                );
              })}
            </div>
            {arrows && (slides?.length > current + 1) && (
              <button
                className={'swiper_preview_button swiper_preview_button_next'}
                onClickCapture={() => swiperRef.current.slideNext()}
              ><NextSliderArrow /></button>
            )}
          </div>
        )}
        {dots && (
          <div className={'swiper_pagination'}>
            {slides.map((_, index) => {
              return (
                <div
                  className={classNames('swiper-pagination-bullets', { active: current === index })}
                  key={index}
                  onClick={() => swiperRef.current?.slideTo(index)}
                />
              );
            })}
          </div>
        )}
      </div>
      {(DV.isNotEmptyString(slides[current]?.title) || DV.isNotEmptyString(slides[current]?.description)) && (
        <div className={'description'}>
          <span>{slides[current].title}</span>
          {DV.isString(slides[current].description) && (
            <div dangerouslySetInnerHTML={{ __html: slides[current].description }} />
          )}
        </div>
      )}
    </div>
  );
}

GallerySlider.defaultProps = {
  dots:      true,
  arrows:    true,
  previews:  false,
  showTitle: false,
  infinite:  false,
  fullSize:  false,
};

export default GallerySlider;